module.exports = __webpack_public_path__ + "img/nasa-ads.e9113aed.png";